import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { site } from '../data/site';

const CANONICAL_ORIGIN = 'https://www.nikhiljewellers.com';

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

/**
 * Per-route title/description/canonical + Open Graph. Written directly to the
 * document head so we don't pull in a helmet dependency for six pages.
 */
export default function Seo({ title, description, image = '/assets/products/arch-bridal-collar.webp' }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const full = title ? `${title} · ${site.name}` : `${site.name} — ${site.tagline}, ${site.city}`;
    document.title = full;

    const desc =
      description ||
      `${site.name}, ${site.city}. Kundan, polki and diamond jewellery since ${site.since}.`;
    const url = `${CANONICAL_ORIGIN}${pathname}`;
    const img = `${CANONICAL_ORIGIN}${image}`;

    upsertMeta('meta[name="description"]', { name: 'description', content: desc });
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: full });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: desc });
    upsertMeta('meta[property="og:url"]', { property: 'og:url', content: url });
    upsertMeta('meta[property="og:image"]', { property: 'og:image', content: img });
    upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: full });
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: desc });
    upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: img });

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }, [title, description, image, pathname]);

  return null;
}
